export default __webpack_public_path__ + "static/media/TikTok_ProfilePage_Final.fa1993de.jpeg";